export const Register = (function() {
    'use strict';

    let urlParams,
        queryString,
        queryStringInput;

    function init() {
        queryString = null;
        queryStringInput = document.querySelector('[data-field-name="query_string"]');                
        urlParams = new URLSearchParams(window.location.search);

        // if a course slug is present in the url, add it to urlParams
        const currentUrl = window.location.href;
        const urlArray = currentUrl.split('/');
        if(currentUrl.includes('/courses/')){
            const coursesIndex = urlArray.indexOf('courses');
            if(urlArray.length > coursesIndex + 1){
                const courseSlug = urlArray[coursesIndex + 1];
                urlParams.set('course', courseSlug);
            }
        }

        // exclude search parameter
        if(urlParams.has('s')) {
            urlParams.delete('s');
        }

        if(sessionStorage.getItem('registerQueryString')){
            queryString = sessionStorage.getItem('registerQueryString');
            urlParams = new URLSearchParams(queryString);
        } else if(urlParams){
            queryString = urlParams.toString();
            sessionStorage.setItem('registerQueryString', queryString);
        }

        if(queryString !== null ){
            if(queryStringInput){
                queryStringInput.value = queryString;
            }

            for(let param of urlParams) {
                let paramInput = document.querySelector('[data-field-name="' + param[0] + '"]');
                if(paramInput){
                    paramInput.value = param[1];
                }
            }    
        }

        controlModalFocusState();
        controlMenuFocusState();
    }

    function controlModalFocusState() {
        let openBtn = document.querySelector('.ld-login-button');
        let closeBtn = document.querySelector('.ld-login-modal .ld-modal-closer');
        let firstInput = document.getElementById('user_login');

        openBtn.addEventListener('click', function() {
            setTimeout(() => {
                firstInput.focus();
            }, 300);
            firstInput.focus();
        });

        closeBtn.addEventListener('click', function() {
            openBtn.focus();
        });
    }

    function controlMenuFocusState() {
        let mobileMenu = document.getElementById('menu-menu-1');
        let openBtn = document.querySelector('.mobile-menu-button--open');
        let closeBtn = document.querySelector('.mobile-menu-button--close');

        openBtn.addEventListener('click', function() {
            setTimeout(() => {
                closeBtn.focus();
            }, 300);
        });

        closeBtn.addEventListener('click', function() {
            openBtn.focus();
        });
    }

    function trapModalFocus(){

    }

    return {
        init: init
    };
})();

// trap focus within modal
document.addEventListener('DOMContentLoaded', () => {
    const modal = document.querySelector('.ld-login-modal-login');
    const focusableElementsSelector = 'button, [href], input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
    let firstFocusableElement;
    let lastFocusableElement;

    function setFocusableElements() {
        const focusableElements = modal.querySelectorAll(focusableElementsSelector);
        firstFocusableElement = focusableElements[0];
        lastFocusableElement = focusableElements[focusableElements.length - 1];
    }

    function handleTabKey(event) {
        if (event.key === 'Tab') {
            if (event.shiftKey) { // Shift + Tab
                if (document.activeElement === firstFocusableElement) {
                    event.preventDefault();
                    lastFocusableElement.focus();
                }
            } else { // Tab
                if (document.activeElement === lastFocusableElement) {
                    event.preventDefault();
                    firstFocusableElement.focus();
                }
            }
        }
    }

    modal.addEventListener('focusin', setFocusableElements);
    modal.addEventListener('keydown', handleTabKey);
});

// trap focus within mobile menu
document.addEventListener('DOMContentLoaded', () => {
    const modal = document.querySelector('#menu-menu-1');
    const focusableElementsSelector = 'button, [href], input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
    let firstFocusableElement;
    let lastFocusableElement;

    function setFocusableElements() {
        const focusableElements = modal.querySelectorAll(focusableElementsSelector);
        firstFocusableElement = focusableElements[0];
        lastFocusableElement = focusableElements[focusableElements.length - 1];
    }

    function handleTabKey(event) {
        // Only trap focus when menu is open
        if (!document.body.classList.contains('mobile-menu-open')) {
            return;
        }

        if (event.key === 'Tab') {
            if (!firstFocusableElement || !lastFocusableElement) {
                setFocusableElements();
            }

            if (event.shiftKey) { // Shift + Tab
                if (document.activeElement === firstFocusableElement) {
                    event.preventDefault();
                    lastFocusableElement.focus();
                }
            } else { // Tab
                if (document.activeElement === lastFocusableElement) {
                    event.preventDefault();
                    firstFocusableElement.focus();
                }
            }
        }
    }

    // Listen on document level to catch all keyboard events
    document.addEventListener('keydown', handleTabKey);
});